<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.plans.create.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.plans.create.hint' | translate }}</p>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="plan-market">
      <span class="av-meta">{{ 'backoffice.plans.create.market' | translate }}</span>
      <select id="plan-market" class="av-field" formControlName="market_id">
        <option value="">{{ 'backoffice.plans.create.choose_market' | translate }}</option>
        @for (market of data.markets; track market.id) {
          <option [value]="market.id">{{ market.displayName }} ({{ market.currency }})</option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="plan-code">
      <span class="av-meta">{{ 'backoffice.plans.create.code' | translate }}</span>
      <input
        id="plan-code"
        type="text"
        class="av-field"
        [attr.maxlength]="codeMax"
        formControlName="code"
      />
    </label>

    <label class="d-flex flex-column gap-1" for="plan-name">
      <span class="av-meta">{{ 'backoffice.plans.create.name' | translate }}</span>
      <input
        id="plan-name"
        type="text"
        class="av-field"
        [attr.maxlength]="nameMax"
        formControlName="name"
      />
    </label>

    <label class="d-flex flex-column gap-1" for="plan-version">
      <span class="av-meta">{{ 'backoffice.plans.create.version' | translate }}</span>
      <input id="plan-version" type="number" min="1" class="av-field" formControlName="version" />
    </label>

    <label class="d-flex align-items-center gap-2">
      <input type="checkbox" formControlName="is_active" />
      <span class="av-section-hint">{{ 'backoffice.plans.create.active' | translate }}</span>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.plans.create.confirm' | translate }}
  </button>
</mat-dialog-actions>
